import {inject, Injectable} from '@angular/core';
import {Storage} from '@ionic/storage-angular';
import {StorageKey} from '../utils/constants/storageKeys';

@Injectable({
  providedIn: 'root'
})
/**
 * Servicio para almacenamiento local usando Ionic Storage Angular
 */
export class StorageService {
  private storage = inject(Storage);
  private _storage: Storage | null = null;

  constructor() {
    this.init();
  }

  async init() {
    const storage = await this.storage.create();
    this._storage = storage;
  }

  public async set(key: StorageKey, value: any) {
    await this._storage?.set(key, value);
  }

  public async get(key: StorageKey) {
    if (key) {
      const data = await this._storage?.get(key);

      if (data) {
        try {
          return data;
        } catch (error) {
          console.error('Error parsing data from storage:', error);
          return null;
        }
      }
    }
    return null;
  }

  public remove(key: StorageKey) {
    this._storage?.remove(key);
  }
}
